<div class="page-container content-w-98">
  <div class="page-head">
    <div>
      <div class="page-title">
        <p class="headerName">{{ headerData.materialName }}</p>
      </div>
    </div>
  </div>
  <div class="responsive-height" [ngClass]="{ 'disabled-project': scenarioData?.isLockProject }">
    <div class="row">
      <div
        class="col-md-12"
        *ngrxLet="{
          dataLoaded: (sharedFacade.isLoaded$ | async),
          isClearSearch: (sharedFacade.isClearSearch$ | async)
        } as sharedData"
      >
        <piqet-angular-portlet
          [class]="'detail-cell-renderer'"
          [class]="'fixedHeight'"
          [columnDefs]="columnDefs"
          [frameworkComponents]="frameworkComponents"
          [searchInputSize]="true"
          (inlineDataEditEvent)="editRecord($event)"
          [createAccess]="showEdit"
          [headerBtn]="'Add new scenario'"
          [gridData]="scenarioData?.scenarioList"
          [pageNo]="$any(scenarioData?.scenarioList)?.draw"
          (openBtnModal)="addNewScenario()"
          [hidePagination]="true"
          [gridName]="gridName"
          [hideSideBar]="isHideSideBar"
          [isClearSearch]="sharedData.isClearSearch"
          [isSetWidth]="false"
          (changeRowOrder)="changeRowOrder($event)"
        ></piqet-angular-portlet>
      </div>
    </div>
  </div>
</div>
